/* eslint-disable better-mutation/no-mutation */
import initData from 'init-data';
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    list: [],
    topLevelCategories:
        initData.allCategories?.map(({ id, name, href }) => ({
            id,
            title: name,
            href
        })) || [],
    isFetching: false,
    error: null
};

const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        initialize: (state, { payload }) => {
            state.topLevelCategories =
                payload.topLevelCategories || state.topLevelCategories;
        },
        requestCategoryList: (state) => {
            state.isFetching = true;
            state.error = null;
        },
        receiveCategoryList: (state, action) => {
            state.list = action.payload;
            state.isFetching = false;
            state.error = null;
        },
        handleCategoryListError: (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
        }
    }
});

export const reducer = categoriesSlice.reducer;

export const {
    initialize,
    requestCategoryList,
    receiveCategoryList,
    handleCategoryListError
} = categoriesSlice.actions;
